import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  // Verificar si el usuario está autenticado
  if (!isAuthenticated()) {
    // Redirigir al login si no está autenticado
    return <Navigate to="/login" replace />;
  }
  
  // Si está autenticado, renderizar los children
  return children;
};

export default ProtectedRoute; 